import * as Yup from "yup";
export const EditPartnerQuotesSchema = Yup.object().shape({
	status : Yup.string().required("Veuillez renseigner un status"),
	signedAt : Yup.string().required("Veuillez renseigner une date de signature"),
	profit : Yup.number().required("Veuillez renseigner le montant d’apport d’affaire (HT)"),
	total : Yup.number().required("Veuillez renseigner le montant du devis (HT)"),
})
